// extracted by mini-css-extract-plugin
export default {"item":"_3GOepf","itemContent":"KHCyL_","name":"a4ACn4","imgContainer":"SVDRQF","description":"iQR5dy","type":"ZsTsLC","img":"G4FTXp"};